import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
const { FreeBookingMessage1, FreeBookingMessage2 } = window['runConfig'];

const useStyles = makeStyles(theme => ({

    box100per: {
        width: "100%",
        height: "50px",
        margin: "5% 0% 5% 0%"
    }
}));

const FreeTicketForm = (props) => {
    const classes = useStyles();

    return (
        <div className={classes.box100per}>
            <Grid container justify="center" item xs={12} ms={12} lg={12}>
                <Typography color="textSecondary" >
                    {FreeBookingMessage1}
                </Typography>
                <br />
                <Typography color="textSecondary" >
                    {FreeBookingMessage2}
                </Typography>
            </Grid>
        </div>
    );
}

export default FreeTicketForm;